// Traces de pattes le long d'un trajet libre (la souris) — fonctions pures, sans DOM.
// Une empreinte tous les `spacing` cases parcourues, alternativement à gauche et à droite de la
// trajectoire, orientée dans le sens de marche. Coordonnées en cases continues (centre de la case
// (x, y) = x + 0.5), comme les empreintes du rat (core/chase.js).
import { TRAIL_SPACING, TRAIL_SIDE_OFFSET, TRAIL_MAX_PRINTS } from '../config/constants.js';

/** @returns {{ last: {x:number,y:number}, travelled: number, prints: object[] }} trace vide en `start` */
export function createTrail(start) {
  return { last: { x: start.x, y: start.y }, travelled: 0, prints: [] };
}

/** Prolonge la trace jusqu'à `pos`, en posant les empreintes dues sur le segment parcouru. */
export function extendTrail(trail, pos) {
  const dx = pos.x - trail.last.x;
  const dy = pos.y - trail.last.y;
  const length = Math.hypot(dx, dy);
  if (length < 1e-6) return trail;
  const prints = [...trail.prints];
  const angle = Math.atan2(dy, dx);
  // Perpendiculaire unitaire à la marche, pour décaler pattes gauche et droite
  const px = -dy / length;
  const py = dx / length;
  let travelled = trail.travelled;
  let along = 0;
  while (travelled + (length - along) >= TRAIL_SPACING) {
    along += TRAIL_SPACING - travelled;
    travelled = 0;
    const side = prints.length % 2 === 0 ? -1 : 1;
    const t = along / length;
    prints.push({
      x: trail.last.x + dx * t + px * side * TRAIL_SIDE_OFFSET,
      y: trail.last.y + dy * t + py * side * TRAIL_SIDE_OFFSET,
      angle,
    });
  }
  travelled += length - along;
  return {
    last: { x: pos.x, y: pos.y },
    travelled,
    prints: prints.length > TRAIL_MAX_PRINTS ? prints.slice(-TRAIL_MAX_PRINTS) : prints,
  };
}

/**
 * Empreintes à dessiner : sans celles à moins de `clearance` cases de `near` (sous le corps de
 * l'animal ou collées à lui), avec un âge de 1 (la plus ancienne) à 0 (la plus récente restante).
 */
export function fadePrints(prints, near, clearance) {
  const visible = near && clearance > 0
    ? prints.filter((p) => Math.hypot(p.x - near.x, p.y - near.y) >= clearance)
    : prints;
  const last = Math.max(1, visible.length - 1);
  return visible.map((p, i) => ({ ...p, age: 1 - i / last }));
}
